<script setup>
import { useBreakpoints } from '@daysmart/daysmart-vue-components/composables'

// import { Size } from '@daysmart/daysmart-vue-components/composables/useBreakpoints.ts'

const { higherThan: isBreakpointHigherThan } = useBreakpoints()
const isDesktop = computed(() => isBreakpointHigherThan.value('md'))
</script>

<template>
  <ScheduleFiltersLayoutDesktop v-if="isDesktop">
    <slot />
  </ScheduleFiltersLayoutDesktop>
  <ScheduleFiltersLayoutMobile v-else>
    <slot />
  </ScheduleFiltersLayoutMobile>
</template>
